import { render, staticRenderFns } from "./DailyAssignmentRooms.vue?vue&type=template&id=631b2318&"
import script from "./DailyAssignmentRooms.vue?vue&type=script&lang=js&"
export * from "./DailyAssignmentRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports